import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {GLTF, GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {PickHelper} from "./helpers/Picker";
import {Group, Mesh, Vector2, Vector2tuple} from "three";

export interface NamedCube {
    name: string;
    cube: THREE.Object3D;
    polar: THREE.Vector2;
}

export class Game {
    private scene: THREE.Scene;
    private camera: THREE.PerspectiveCamera;
    private renderer: THREE.WebGLRenderer;
    private controls: OrbitControls;
    private loader: GLTFLoader;
    private cubes: NamedCube[] = [];
    private world?: THREE.Object3D;
    private picker: PickHelper = new PickHelper();

    public constructor() {
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.scene.add(this.camera);

        this.renderer = new THREE.WebGLRenderer();
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        document.body.appendChild(this.renderer.domElement);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);

        this.camera.position.z = 15;
        this.loader = new GLTFLoader();
        this.populate_scene();

        window.addEventListener('click', (event) => this.click(event));
    }

    public populate_scene(): THREE.Scene {

        const light = new THREE.PointLight(0x8888ee, 1.5, 100);
        light.position.set(0, 0, 5);
        this.camera.add(light);
        const ambientLight = new THREE.AmbientLight(0x111111, 0.5);
        this.scene.add(ambientLight);

        const models = require('../assets/models/*.glb');
        this.loader.load(models.Earth_1_12756, (gltf:GLTF) => {
            gltf.scene.scale.set(0.01, 0.01, 0.01);
            this.scene.add(gltf.scene);
            this.world = gltf.scene.children[0];
        }, function (p: ProgressEvent) {
            console.log(p);
        }, function (error: ErrorEvent) {
            console.error(error);
        });

        const geometry = new THREE.BoxGeometry();
        const material = new THREE.MeshBasicMaterial({color: 0x00ff00});
        this.cubes = [
            {
                name: "europa",
                cube: new THREE.Mesh(geometry, material),
                polar: new Vector2(1.65,-0.65),
            },
            {
                name: "amerika",
                cube: new THREE.Mesh(geometry, material),
                polar: new Vector2(0.9, 0.1),
            },
            {
                name: "afrika",
                cube: new THREE.Mesh(geometry, material),
                polar: new Vector2(1.6, -1.2),
            },
        ];
        this.cubes.forEach((named_cube: NamedCube, index)=>{
            const x = Math.cos( named_cube.polar.x ) * 5;
            const y = Math.sin( named_cube.polar.x ) * Math.cos( named_cube.polar.y ) * 5;
            const z = Math.sin( named_cube.polar.x ) * Math.sin( named_cube.polar.y ) * 5;
            named_cube.cube.translateX(x) ;
            named_cube.cube.translateY(y);
            named_cube.cube.translateZ(z);
            this.scene.add(named_cube.cube);
        });

        return this.scene;
    }

    public update(delta_seconds: number) {
        if (! (this.world instanceof Mesh)) return false;
        this.renderer.render(this.scene, this.camera);
        // if (this.cube) this.cube.translateX(delta_seconds);
        // this.picker.pick(new THREE.Vector2(0, 0), this.scene, this.world, this.camera, Math.random());
    }

    public click(event: MouseEvent) {
        if (! (this.world instanceof Mesh) || !this.cubes) return false;
        const pick_position = this.get_pick_position(event);
        this.picker.pick(pick_position, this.cubes,  this.world, this.camera, Math.random());
    }

    public get_canvas_relative_position(event: MouseEvent) : { x:number, y:number }{
        const canvas = this.renderer.getContext().canvas;
        if (!(canvas instanceof HTMLCanvasElement)) return {x:0,y:0};
        const rect = canvas.getBoundingClientRect();
        return {
            x: (event.clientX - rect.left) * canvas.width / rect.width,
            y: (event.clientY - rect.top) * canvas.height / rect.height,
        };
    }

    public get_pick_position(event: MouseEvent): Vector2 {
        const canvas = this.renderer.getContext().canvas;
        const normal_position = this.get_canvas_relative_position(event);
        const x = (normal_position.x / canvas.width ) *  2 - 1;
        const y = (normal_position.y / canvas.height) * -2 + 1;  // note we flip Y

        return new Vector2(x,y);
    }
}

